import React, { Component } from "react";
import firebase from "firebase";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common
import { api } from "../../common/ApiPromisify";
//ClientLibsReference
import { Belfastpilatesappspotcom } from "../../common/ClientLibsReference";

class Login extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      email: "",
      password: "",
      showPassword: false,
    };
  }

  handleSubmitFirebase = () => {
    this.setState({ loading: true });

    firebase
      .auth()
      .signInWithEmailAndPassword(this.state.email, this.state.password)
      .then(() => {
        firebase.auth().currentUser.reload();
        firebase
          .auth()
          .currentUser.getIdToken(true)
          .then((idToken) => {
            localStorage.setItem("firebaseIdToken", idToken);
            this.handleSubmitLogin();
          });
      })
      .catch((err) => {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: err.message,
          life: 6000,
        });
      });

    this.setState({ loading: false });
  };

  handleSubmitLogin = async () => {
    this.setState({ loading: true });

    let loginRequest = new Belfastpilatesappspotcom.LoginRequest();
    if (localStorage.getItem("globalBid")) {
      loginRequest.codeTag = localStorage.getItem("globalBid");
    } else {
      loginRequest.codeTag = "BID00000000000000000001";
    }
    loginRequest.userEmail = this.state.email;

    await api("loginApiV1Login", loginRequest).then((res) => {
      if (res.data) {
        let loginResponse =
          Belfastpilatesappspotcom.LoginResponse.constructFromObject(res.data);

        if (loginResponse.errorCode === 0) {
          if (loginResponse.roleType === "30") {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail: "User not authorised",
              life: 6000,
            });
          } else {
            localStorage.setItem("globalBid", loginResponse.codeTag);
            localStorage.setItem("email", this.state.email);

            Object.entries(loginResponse).forEach(([key, value]) => {
              localStorage.setItem(key, value);
            });

            window.location.reload();
          }
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "User has been deleted or does not exist, please contact an administrator",
            life: 6000,
          });
        }
      } else {
        console.log("loginApiV1Login has failed");
      }
    });

    this.setState({ loading: false });
  };

  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.handleSubmitFirebase();
    }
  };

  render() {
    return (
      <div className="login-page" onKeyPress={this.handleKeyPress}>
        <pr.Growl
          style={{ textAlign: "left" }}
          ref={(el) => (this.growl = el)}
        />
        <div className="ui-g">
          <div className="card login-panel ui-fluid">
            <div className="ui-g">
              <div className="ui-g-12" style={{ padding: "20px 40px" }}>
                <img
                  src="/assets/layout/images/bpp/bpp-logo.png"
                  alt=""
                  height="100%"
                  width="100%"
                />
              </div>
              <div className="ui-g-12" style={{ padding: "20px 40px" }}>
                <span className="md-inputfield form-field">
                  <pr.InputText
                    value={this.state.email || ""}
                    onChange={(e) => {
                      this.setState({
                        email: e.target.value,
                      });
                    }}
                  />
                  <label>Email Address</label>
                </span>
              </div>
              <div className="ui-g-12" style={{ padding: "20px 40px" }}>
                <div className="ui-g-10" style={{ padding: "0" }}>
                  <span className="md-inputfield">
                    {this.state.showPassword ? (
                      <pr.InputText
                        value={this.state.password || ""}
                        onChange={(e) => {
                          this.setState({
                            password: e.target.value,
                          });
                        }}
                      />
                    ) : (
                      <pr.Password
                        feedback={false}
                        promptLabel="Strength"
                        value={this.state.password || ""}
                        onChange={(e) => {
                          this.setState({
                            password: e.target.value,
                          });
                        }}
                      />
                    )}
                    <label>Password</label>
                  </span>
                </div>
                <div className="ui-g-2">
                  <pr.Button
                    className="secondary-btn"
                    icon={
                      this.state.showPassword ? "pi pi-eye-slash" : "pi pi-eye"
                    }
                    onClick={() => {
                      this.setState({ showPassword: !this.state.showPassword });
                    }}
                    style={{ margin: "0" }}
                  />
                </div>
              </div>
              <div className="ui-g-12" style={{ padding: "20px 40px" }}>
                <pr.Button
                  label="Sign In"
                  icon={
                    this.state.loading
                      ? "pi pi-spin pi-spinner"
                      : "pi pi-sign-in"
                  }
                  onClick={() => {
                    this.handleSubmitFirebase();
                  }}
                />
                <span className="ui-float-label">
                  <a href="#/password">Forgot Password?</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/Login.js